import {
	ApplySupplierPriceImportMutation,
	CancelSupplierPriceExtractionMutation,
	CancelSupplierPriceImportApprovalMutation,
	CreateSupplierPriceImportMutation,
	DecideSupplierPriceImportRowMutation,
	DiscardSupplierPriceImportMutation,
	ReviewSupplierPriceImportRowMutation,
	SelectSupplierPriceImportRowMutation
} from "~/gql/mutations/produce/supplierPriceImport.generated";
import {
	GetSupplierPriceImportApplyQuery,
	GetSupplierPriceImportHeldRowsQuery,
	GetSupplierPriceImportQuery,
	GetSupplierPriceImportRowCandidatesQuery,
	GetSupplierPriceImportRowsQuery,
	GetSupplierPriceImportsQuery
} from "~/gql/queries/produce/supplierPriceImport.generated";

const supplierPriceImportEndpoints = {
	ApplySupplierPriceImport: {
		invalidatesTags: [
			"SupplierPriceImport",
			"MaterialItems",
			"VendorMaterialCosts",
			"JobCosts",
			"ProductionJobs",
			"ProductionRecipe"
		] as AddTagTypes,
		transformResponse: (res: ApplySupplierPriceImportMutation) => {
			return res;
		}
	},
	CancelSupplierPriceExtraction: {
		invalidatesTags: ["SupplierPriceImport"] as AddTagTypes,
		transformResponse: (res: CancelSupplierPriceExtractionMutation) => {
			return res;
		}
	},
	CancelSupplierPriceImportApproval: {
		invalidatesTags: ["SupplierPriceImport"] as AddTagTypes,
		transformResponse: (res: CancelSupplierPriceImportApprovalMutation) => {
			return res;
		}
	},
	CreateSupplierPriceImport: {
		invalidatesTags: ["SupplierPriceImport"] as AddTagTypes,
		transformResponse: (res: CreateSupplierPriceImportMutation) => {
			return res;
		}
	},
	DecideSupplierPriceImportRow: {
		invalidatesTags: ["SupplierPriceImport"] as AddTagTypes,
		transformResponse: (res: DecideSupplierPriceImportRowMutation) => {
			return res;
		}
	},
	DiscardSupplierPriceImport: {
		invalidatesTags: ["SupplierPriceImport"] as AddTagTypes,
		transformResponse: (res: DiscardSupplierPriceImportMutation) => {
			return res;
		}
	},
	GetSupplierPriceImport: {
		providesTags: ["SupplierPriceImport"] as AddTagTypes,
		transformResponse: (res: GetSupplierPriceImportQuery) => {
			return res;
		}
	},
	GetSupplierPriceImportApply: {
		providesTags: ["SupplierPriceImport"] as AddTagTypes,
		transformResponse: (res: GetSupplierPriceImportApplyQuery) => {
			return res;
		}
	},
	GetSupplierPriceImportHeldRows: {
		providesTags: ["SupplierPriceImport"] as AddTagTypes,
		transformResponse: (res: GetSupplierPriceImportHeldRowsQuery) => {
			return res;
		}
	},
	GetSupplierPriceImportRowCandidates: {
		transformResponse: (res: GetSupplierPriceImportRowCandidatesQuery) => {
			return res;
		}
	},
	GetSupplierPriceImportRows: {
		providesTags: ["SupplierPriceImport"] as AddTagTypes,
		transformResponse: (res: GetSupplierPriceImportRowsQuery) => {
			return res;
		}
	},
	GetSupplierPriceImports: {
		providesTags: ["SupplierPriceImport"] as AddTagTypes,
		transformResponse: (res: GetSupplierPriceImportsQuery) => {
			return res;
		}
	},
	ReviewSupplierPriceImportRow: {
		invalidatesTags: ["SupplierPriceImport"] as AddTagTypes,
		transformResponse: (res: ReviewSupplierPriceImportRowMutation) => {
			return res;
		}
	},
	SelectSupplierPriceImportRow: {
		invalidatesTags: ["SupplierPriceImport"] as AddTagTypes,
		transformResponse: (res: SelectSupplierPriceImportRowMutation) => {
			return res;
		}
	}
};

export default supplierPriceImportEndpoints;
